import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/auth/AuthContext";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Area riservata | EMME SERVICE CAR";
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  const inputCls =
    "w-full rounded-md border border-edge bg-carbon px-4 py-3 text-sm text-ice placeholder:text-steel/60 focus:border-amber focus:outline-none focus:ring-1 focus:ring-amber";

  return (
    <div className="flex min-h-screen items-center justify-center bg-carbon px-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex justify-center"><Logo /></div>
        <div className="rounded-2xl border border-edge bg-asphalt p-8">
          <div className="mb-6 flex items-center gap-2 text-amber">
            <Lock className="h-5 w-5" />
            <h1 className="font-display text-xl font-bold text-ice">Area riservata</h1>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label htmlFor="email" className="mb-1.5 block text-sm text-steel">Email</label>
              <input id="email" type="email" data-testid="login-email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required />
            </div>
            <div>
              <label htmlFor="password" className="mb-1.5 block text-sm text-steel">Password</label>
              <input id="password" type="password" data-testid="login-password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
            </div>
            {error && <p data-testid="login-error" className="text-sm text-destructive">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-amber px-6 py-3 font-display text-sm font-bold uppercase text-carbon transition-colors hover:bg-amber/90 disabled:opacity-70"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
              Accedi
            </button>
          </form>
        </div>
        <p className="mt-6 text-center text-xs text-steel">EMME SERVICE CAR — Pannello richieste</p>
      </div>
    </div>
  );
}
